import { graphql } from '@apollo/react-hoc';

import Properties from './Properties.graphql';
import Property from './Property.graphql';
import CreateProperty from './CreateProperty.graphql';
import UpdateProperty from './UpdateProperty.graphql';
import DeleteProperty from './DeleteProperty.graphql';

export const PropertiesQuery = Properties;
export const PropertyQuery = Property;
export const CreatePropertyMutation = CreateProperty;
export const UpdatePropertyMutation = UpdateProperty;
export const DeletePropertyMutation = DeleteProperty;

const withPropertyRead = graphql(PropertyQuery, {
  options: ({ id, propertyPermissions, personPermissions }) => ({
    variables: {
      id,

      propertiesSeeSensitiveData: Boolean(
        propertyPermissions?.seeSensitiveData,
      ),

      personsSeeSensitiveData: Boolean(personPermissions?.seeSensitiveData),
    },
  }),
  props: ({ data: { property, loading, refetch } }) => ({
    property,
    loading,
    refetch,
  }),
});

const withPropertyCreate = graphql(CreatePropertyMutation, { name: 'create' });
const withPropertyUpdate = graphql(UpdatePropertyMutation, { name: 'update' });
const withPropertyDelete = graphql(DeletePropertyMutation, { name: 'remove' });

export {
  withPropertyCreate,
  withPropertyRead,
  withPropertyUpdate,
  withPropertyDelete,
};
